module.exports = __webpack_public_path__ + "img/bell_unknow.e2679eeb.png";